import React from 'react';
import PropTypes from 'prop-types';

const ArticleLandscapeImage = ({ img }) => {
  return (
    <div className="article-landscape">
      <div className="article-landscape__wrapper">
        <div
          className="article-landscape__overflow"
          data-scroll=""
          data-scroll-speed="-1"
        >
          <img
            src={`https://admin.shoschool.com${img?.url}`}
            alt="картинка блога"
            className="article-landscape__image"
          />
        </div>
      </div>
    </div>
  );
};

ArticleLandscapeImage.propTypes = {
  img: PropTypes.object,
};

export default ArticleLandscapeImage;
